import {
  FleetFuelType,
  FleetStatus
} from "../../../components/FleetManagement/types/FleetManagement.types";
import { BookingVehicleInfo } from "../../../components/FleetManagement/types/FleetManagement-row.types";
import { BookableBookingObjectDto } from "../typings/resource-calendar.types";

/**
 * Resource catalog rows do not include full fleet metadata. This stub allows the
 * normal vehicle confirm UI to render with limited fields until fleet data is wired.
 */
export function createStubFleetVehicleForResourceBooking(
  row: BookableBookingObjectDto
): BookingVehicleInfo {
  return {
    id: row.bookingInventoryId,
    name: row.objectName,
    description: null,
    picturePaths: null,
    licensePlate: "—",
    brandModel: row.displayLabel ?? row.objectName,
    vehicleType: null,
    fuel: FleetFuelType.Electric,
    reach: 0,
    numSeats: 0,
    properties: [],
    status: FleetStatus.Available,
    odometer: null,
    adminNotes: null,
    userNotes: null,
    contractDetails: null,
    pricePerHour: null,
    bufferMinutes: null,
    fleetPermissions: {
      activeWeekdays: [],
      companies: [],
      costCenterUnits: [],
      users: [],
      ownerId: null
    },
    affectedCompanies: [],
    affectedDepartments: [],
    affectedUsers: []
  };
}
